import { IconButton } from 'components/button'
import { Box, Flex } from 'components/elements'
import { LeftArrowIcon } from 'components/icons'
import { IncidentDetail } from 'features/incidents/components/CardDetail'
import { MainWrapCSS } from 'features/incidents/components/style'
import { IncidentDetailsProps } from 'features/incidents/components/type'

type ArrayFieldConfig = {
  fieldName: string
  titlePrefix: string
}

type InventoryDetailsProps = IncidentDetailsProps & {
  arrayFields?: ArrayFieldConfig[]
}

const InventoryDetails = ({
  row,
  onExpand,
  isDesktopOrLaptop,
  arrayFields = [], // Default to empty array if not provided
}: InventoryDetailsProps) => {
  // Filter out array fields from the main details
  const filteredRow = Object.entries(row).reduce((acc, [key, value]) => {
    if (!Array.isArray(value) && !arrayFields.some(field => field.fieldName === key)) {
      return { ...acc, [key]: value }
    }
    return acc
  }, {} as Record<string, string>)

  return (
    <>
      <Box className="detail-box" style={{ padding: 0 }}>
        {!isDesktopOrLaptop && (
          <IconButton onClick={onExpand} className="back--button">
            <LeftArrowIcon />
            <Box as="p" css={{ margin: '0 0 0 1.5rem' }}>
              Inventory Details
            </Box>
          </IconButton>
        )}
        <Flex direction="column" wrap="wrap" css={MainWrapCSS}>
          <IncidentDetail fields={filteredRow} hideBorder={true} title="Inventory Details" />
          {arrayFields.map(
            ({ fieldName, titlePrefix }) =>
              Array.isArray(row?.[fieldName]) &&
              row?.[fieldName].map((item: Record<string, string>, index: number) => <IncidentDetail key={index} title={`${titlePrefix} ${index + 1}`} fields={item} />)
          )}
        </Flex>
      </Box>
    </>
  )
}

export default InventoryDetails
